import React from 'react';
import FeedbackBankComponent from './FeedbackBankComponent';

export default function FeedbackBankContainer() {
  return <FeedbackBankComponent />;
}
